export default function generatePaginationButtons(currentPage, total, perPage, maxVisibleButtons) {
  const buttons = [];

  const totalPages = Math.ceil(total / perPage);
  let startPage = 1;
  let endPage = totalPages;

  if (totalPages > maxVisibleButtons) {
    const half = Math.floor(maxVisibleButtons / 2);
    startPage = Math.max(currentPage - half, 1);
    endPage = startPage + maxVisibleButtons - 1;
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = endPage - maxVisibleButtons + 1;
    }
    if (startPage > 1) {
      buttons.push({ text: '1', key: '1' });
      if (startPage > 2) {
        // Generate unique key for ellipsis button
        const ellipsisKey = `...${startPage}`;
        buttons.push({ text: '...', key: ellipsisKey });
      }
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    buttons.push({ text: `${i}`, key: `${i}` });
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      // Generate unique key for ellipsis button
      const ellipsisKey = `...${endPage}`;
      buttons.push({ text: '...', key: ellipsisKey });
    }
    buttons.push({ text: `${totalPages}`, key: `${totalPages}` });
  }

  return buttons;
}
